const AudioContext = window.AudioContext || window.webkitAudioContext
let ctx = null

function getCtx() {
  if (!ctx) ctx = new AudioContext()
  if (ctx.state === 'suspended') ctx.resume()
  return ctx
}

function playTone(freq, duration, type = 'sine', gain = 0.08, fadeOut = true) {
  try {
    const c = getCtx()
    const osc = c.createOscillator()
    const g = c.createGain()
    osc.type = type
    osc.frequency.value = freq
    g.gain.value = gain
    if (fadeOut) g.gain.exponentialRampToValueAtTime(0.001, c.currentTime + duration)
    osc.connect(g)
    g.connect(c.destination)
    osc.start()
    osc.stop(c.currentTime + duration)
  } catch {}
}

// Soft click — choice selection
export function soundClick() {
  playTone(800, 0.06, 'sine', 0.05)
}

// Generic UI tap — slightly higher than soundClick, very short, low gain.
// Used for any button press across the app via the tap() feedback helper.
export function soundTap() {
  playTone(1100, 0.04, 'sine', 0.035)
}

// Back / dismiss — softer descending tap. Used on back chevrons and modal
// dismiss so it feels distinct from a forward navigation tap.
export function soundTapBack() {
  playTone(700, 0.045, 'sine', 0.035)
}

// Toggle — two-tone snap, used when flipping a switch on/off. The second
// tone is slightly higher when going on, lower when going off.
export function soundToggle(on = true) {
  playTone(900, 0.03, 'sine', 0.04)
  setTimeout(() => playTone(on ? 1200 : 600, 0.05, 'sine', 0.04), 30)
}

// Positive choice — warm ascending
export function soundPositive() {
  playTone(523, 0.12, 'sine', 0.06)
  setTimeout(() => playTone(659, 0.12, 'sine', 0.06), 80)
  setTimeout(() => playTone(784, 0.18, 'sine', 0.05), 160)
}

// Negative/neutral choice — soft descending
export function soundNeutral() {
  playTone(440, 0.15, 'sine', 0.04)
  setTimeout(() => playTone(392, 0.2, 'sine', 0.03), 100)
}

// Connection increase — sparkle
export function soundConnection() {
  playTone(1047, 0.08, 'sine', 0.04)
  setTimeout(() => playTone(1319, 0.08, 'sine', 0.04), 60)
  setTimeout(() => playTone(1568, 0.12, 'sine', 0.03), 120)
}

// New ending discovered — warm 4-note ascending chime (C-E-G-C).
// Used for the minor "ending found" celebration.
export function soundEndingDiscovered() {
  const notes = [523, 659, 784, 1047]
  notes.forEach((f, i) => {
    setTimeout(() => playTone(f, 0.2, 'sine', 0.05), i * 100)
  })
}

// Story complete — bigger, triumphant flourish: a 5-note ascending
// arpeggio followed by a sustained C-major chord. Used when the kid
// has found every ending in a story (major celebration).
export function soundStoryComplete() {
  const arp = [392, 523, 659, 784, 1047]
  arp.forEach((f, i) => {
    setTimeout(() => playTone(f, 0.18, 'sine', 0.06), i * 80)
  })
  setTimeout(() => {
    playTone(523, 0.7, 'sine', 0.05)
    playTone(659, 0.7, 'sine', 0.04)
    playTone(784, 0.7, 'sine', 0.04)
  }, 480)
}

// Heartbeat — for tense moments
let heartbeatInterval = null
export function startHeartbeat(bpm = 80) {
  stopHeartbeat()
  const ms = (60 / bpm) * 1000
  const beat = () => {
    playTone(60, 0.08, 'sine', 0.1, false)
    setTimeout(() => playTone(50, 0.06, 'sine', 0.06, false), 120)
  }
  beat()
  heartbeatInterval = setInterval(beat, ms)
}

export function stopHeartbeat() {
  if (heartbeatInterval) {
    clearInterval(heartbeatInterval)
    heartbeatInterval = null
  }
}

// Auth success — warm welcome chime
export function soundAuthSuccess() {
  playTone(523, 0.15, 'sine', 0.05)
  setTimeout(() => playTone(659, 0.15, 'sine', 0.05), 120)
  setTimeout(() => playTone(784, 0.2, 'sine', 0.04), 240)
  setTimeout(() => playTone(1047, 0.3, 'sine', 0.03), 380)
}
